export default "__VITE_ASSET__CEPgmymT__"